<template>
    <div>
        <h1>Định giá</h1>

        <CRow>
            
        </CRow>

        <CRow>
            <b-button variant="danger" @click="reset()" class="mr-2">Reset</b-button>

            <b-button v-b-toggle.collapse-validation-1 variant="" class="mr-2">Thêm sản phẩm vào giỏ so sánh</b-button>
            <b-button v-b-toggle.collapse-validation-2 variant="">Thêm quét online vào giỏ so sánh</b-button>
        </CRow>
        <CRow>
            
            <b-collapse id="collapse-validation-1" class="mt-2">
                <b-card>
                    <table-view
                        :columns="product.columns"
                        :display_columns="product.display_columns"
                        :filters="product.filters"
                        :table_name="product.table_name"
                        :sorts="product.sorts"
                        @row-clicked="rowClicked"
                    >
                    </table-view>
                </b-card>
            </b-collapse>

            <b-collapse id="collapse-validation-2" class="mt-2">
                <b-card>
                    <table-view
                        :columns="online.columns"
                        :display_columns="online.display_columns"
                        :filters="online.filters"
                        :table_name="online.table_name"
                        :sorts="online.sorts"
                        @row-clicked="rowClickedOnline"
                    >
                    </table-view>
                </b-card>
            </b-collapse>
        </CRow>

        <CRow class="mt-2">
            <!-- <b-card class="col-12"> -->
            <b-table :items="data" 
                :fields="fields" 
                :busy="isLoading" 
                :responsive="false"
                sticky-header
                head-variant="dark"
                striped outlined bordered small >

                <template v-slot:cell()="data">
                  <span v-html="data.value"></span>

                </template>

                <template v-slot:table-busy>
                    <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                    </div>
                </template>
            </b-table>
            <!-- </b-card> -->
        </CRow>
    </div>
</template>

<script>

import ProductService from '@/services/productService'
import OnlineService from '@/services/onlineScanService'
import ProductTableMeta from '@/models/ProductTableMeta'
import GenericTableView from '@/views/base/GenericTableView'
import OnlineTableMeta from '@/models/OnlineScanTableMeta'

export default {
  name: 'Validation',
  components: {
    'table-view': GenericTableView
  },
  data () {
    return {
        data: [],
        fields: [

        ],
        itemToCompare: [
            {
                type: 'online',
                id: 5195
            },
            {
                type: 'product',
                id: 326
            }
        ],

        product: {
            display_columns: ProductTableMeta.list_views.columns,
            columns: ProductTableMeta.columns,
            filters: ProductTableMeta.list_views.filters,
            table_name: ProductTableMeta.table_name,
            sorts: ProductTableMeta.list_views.sorts,
        },

        online: {
            display_columns: OnlineTableMeta.list_views.columns,
            columns: OnlineTableMeta.columns,
            filters: OnlineTableMeta.list_views.filters,
            table_name: OnlineTableMeta.table_name,
            sorts: OnlineTableMeta.list_views.sorts
        },

        display_columns: [
            'date',
            'type',
            'fullname',
            'sale',
            'street',
            'address',
            'usageType',
            'price',
            'pricePerArea',
            'notes',
            'area',
            'areaWidth',
            'areaLength',
            'trait',
            'positive',
            'structure',
            'direction',
            'houseArea',
            'houseAreaWidth',
            'houseAreaLength',
            'houseUsageArea'
        ],
        
        isLoading: false
    }
  },
  
  methods: {
      generateTableViews () {
        this.fields = [];
        for(var i=0; i< this.display_columns.length; i++) {
            var col = this.display_columns[i];
            var f = null;
            var colMeta = {};

            if(typeof col === "string") {
                f = this.product.columns[col];
            }
            else {
                f = this.product.columns[col.key];
                colMeta['variant'] = col.variant;
            }

            if(!f) {
                // this is a virtual column
                colMeta['key'] = col.name;

                this.fields.push(colMeta);
            }
            else {
                colMeta['key'] = f.name;
                colMeta['label'] = f.alias;

                if(f.formatter) {
                    colMeta.formatter = f.formatter;
                }

                this.fields.push(colMeta);
            }
        }
      },

    reset () {
        this.itemToCompare = [];
        this.data = [];
        this.$store.commit('resetItemToCompare');
    },

    async refreshData () {
        this.isLoading = true;
        var productService = new ProductService('realestate.products');
        var onlineService = new OnlineService('realestate.online_scan');

        for(var i=0; i<this.itemToCompare.length; i++) {
            var item = this.itemToCompare[i];
            var recordInfo;

            if(item.type === 'online') {
                recordInfo = await onlineService.getDetail(item.id);
            } else if(item.type === 'product') {
                recordInfo = await productService.getDetail(item.id);
            }

            this.data.push(recordInfo);
        }

        console.log('data: ', this.data);
        this.isLoading = false;
    },

    async rowClicked (event) {
    //   this.$store.commit('addItemToCompare', {type: 'product', id: event.id});
        this.isLoading = true;
      

      var productService = new ProductService('realestate.products');
      var recordInfo = await productService.getDetail(event.id);
      recordInfo._rowVariant='warning';
      this.data.push(recordInfo);

      this.itemToCompare.push({type: 'product', id: event.id});
      this.isLoading = false;
    //   this.refreshData();
    //   alert('Sản phẩm đã được đưa vào danh sách so sánh');

    },

    async rowClickedOnline (event) {
        // this.$store.commit('addItemToCompare', {type: 'online', id: event.id});
        this.isLoading = true;
        var onlineService = new OnlineService('realestate.online_scan');
      var recordInfo = await onlineService.getDetail(event.id);
      this.data.push(recordInfo);
      this.itemToCompare.push({type: 'online', id: event.id});
    //   this.refreshData();
        this.isLoading = false;
    }
  },
  props: [],
  mounted () {
      this.generateTableViews();

      if (this.$store.state.itemToCompare) {
        this.itemToCompare = this.$store.state.itemToCompare;
        this.refreshData();
      }
    
  }
}
</script>

<style scoped>
</style>
